import { render, staticRenderFns } from "./CakeQuestion.vue?vue&type=template&id=0af9a66e"
import script from "./CakeQuestion.vue?vue&type=script&lang=js"
export * from "./CakeQuestion.vue?vue&type=script&lang=js"
import style0 from "./CakeQuestion.vue?vue&type=style&index=0&id=0af9a66e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports